import React, {useState} from 'react';
import s from '../FinancialReport.module.css';
import styleTableGrid from '../../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import style from '../../PaperworkList/PaperworkList.module.css';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';
import ReportTableRowEl from './rows/ReportTableRowEl';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';
import {FinReportType} from '../../../types/StoreReportTypes';

type Props = {
	title: string;
	data: FinReportType[];
};

const CommonReportTable: React.FC<Props> = ({title, data}) => {
	const {t} = useTranslation();
	const [showAll, setShowAll] = useState(false);
	const visibleData = showAll ? data : data.slice(0, 4);

	return (
		<>
			<div className={s.title}>{title}</div>
			<div className={s.reportTableContainer}>
				{/* Обгортка для адаптивного горизонтального скролу */}
				<div className={s.tableWrapper}>
					<div className={styleTableGrid.tableGrid}>
						<GridTableHead
							columns={[
								'Дата початок',
								'Дата кінець',
								'Баланс на початок',
								'Продано за період',
								'Знижка',
								'Виплачено бонусів',
								'Надходження кас. ордер',
								'Баланс на кінець',
							]}
							gridTemplateColumns="repeat(8, 1fr)"
							customClassName={styleTableGrid.tableRow}
						/>
						{visibleData.map((row, index) => (
							<ReportTableRowEl key={row.sold + index} row={row} />
						))}

						{!showAll && data.length > 4 && (
							<div className={style.buttonWrapper}>
								<LightGreenButton
									type={'button'}
									text={t('Дивитись більше')}
									onClick={() => setShowAll(true)}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default CommonReportTable;
